// Imports
import React from "react"
import { Font, FajnyIcon } from "fajny-react"
import { v4 as uuid } from "uuid"

import { Container, Col } from "./styles"

import siteData from "../../data/site-data"
import social from "../../data/social"

const Footer = () => {
    return (
        <Container>
            <Col>
                <Font.P>V{siteData.version}</Font.P>

                {social.map(social =>
                    social.icon === "mail-solid" ? (
                        <a href={social.url} key={uuid()}>
                            <FajnyIcon name={social.icon} size={18} />
                        </a>
                    ) : (
                        <a
                            href={social.url}
                            target="_blank"
                            rel="noreferrer noopener"
                            key={uuid()}
                        >
                            <FajnyIcon name={social.icon} size={18} />
                        </a>
                    )
                )}
            </Col>

            <Font.P textAlign="right">
                Pictures from{" "}
                <a
                    href="https://unsplash.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Unsplash
                </a>
                , videos from{" "}
                <a
                    href="https://mixkit.co/"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Mixkit
                </a>
                .<br />
                Made by {siteData.author} | {siteData.year}
            </Font.P>
        </Container>
    )
}

export default Footer
